const colors = {
  textPrimary: "rgba(188, 179, 164, 1)", // Used for the text "hendrik grygas"
  hoverBrightness: "0.70", // Used for the hover filter brightness
  backgroundOverlay: "rgba(255, 255, 255, 0.9)", // Used for the text box background
  
  lightgray: "rgba(226, 226, 226, 1)",
  gray: "rgb(200, 200, 200)",
  darkGray: "rgb(158, 158, 158)",
  antracite: "rgba(95, 95, 95, 0.99)",
  
  shadowColor: "rgba(0, 0, 0, 0.1)", // Used for the text box shadow
  warmBeige: "rgba(68, 63, 53, 1)", // Used for the footer background color
  backgroundBlue: "rgba(42, 145, 194, 0.5)",
 
  svgHoverFilters: [
    "invert(45%) sepia(80%) saturate(900%) hue-rotate(320deg) brightness(95%) contrast(110%)", // Red 
    "invert(45%) sepia(80%) saturate(900%) hue-rotate(180deg) brightness(95%) contrast(110%)", // Blue
    "invert(45%) sepia(80%) saturate(900%) hue-rotate(240deg) brightness(95%) contrast(110%)", // Purple
    "invert(45%) sepia(80%) saturate(900%) hue-rotate(10deg) brightness(95%) contrast(110%)", // Orange
    "invert(45%) sepia(80%) saturate(900%) hue-rotate(280deg) brightness(80%) contrast(110%)", // Pink
    "invert(45%) sepia(80%) saturate(900%) hue-rotate(90deg) brightness(95%) contrast(110%)", // Green (kept)
  ],

  filterColors: [
    "rgba(228, 90, 90, 0.2)", // Red
    "rgba(70, 123, 202, 0.2)", // Blue
    "rgba(184, 0, 184, 0.2)", // Pink
    "rgba(204, 126, 48, 0.2)", // Orange
    "rgba(128, 50, 128, 0.2)", // Purple
    "rgba(42, 145, 42, 0.2)", // Green (kept)
  ],
};

export default colors;